import { FC, ReactNode } from 'react';

type ActionTone = 'info' | 'edit' | 'danger';

/**
 * Hiérarchie visuelle des actions de ligne.
 *
 * Les deux actions d'ouverture (modifier, consulter) sont pleines et se distinguent par
 * la teinte ; la suppression reste discrète et ne se colore qu'au survol. L'ancien écran
 * affichait les trois en aplat saturé, si bien que le bouton de suppression attirait
 * l'œil autant que l'édition. L'aplat très clair d'origine sur l'action « info » avait
 * l'excès inverse : sur une liste dense, on ne voyait plus qu'elle existait.
 */
const TONE_CLASS: Record<ActionTone, string> = {
  info: 'bg-sky-500 text-white shadow-sm hover:bg-sky-600',
  edit: 'bg-primary text-white shadow-sm hover:bg-primary/90',
  danger: 'text-gray-400 hover:bg-red-50 hover:text-red-600',
};

export interface RowAction {
  tone: ActionTone;
  icon: ReactNode;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export const RowActions: FC<{ actions: RowAction[] }> = ({ actions }) => (
  <div className="flex flex-shrink-0 items-center gap-1.5">
    {actions.map((action) => (
      <button
        key={action.label}
        type="button"
        title={action.label}
        aria-label={action.label}
        disabled={action.disabled}
        onClick={action.onClick}
        className={`flex h-8 w-9 items-center justify-center rounded-md transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${TONE_CLASS[action.tone]}`}
      >
        {action.icon}
      </button>
    ))}
  </div>
);
